export const isEmptyObject = (obj = {}) => {
  if (typeof obj === 'object' && obj !== null) {
    return !Boolean(Object.keys(obj).length)
  } else {
    throw new Error(`Error at isEmpty(...): ${obj} is not an object`)
  }
}

export default isEmptyObject
